/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable security/detect-object-injection */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { TFunction, useTranslation } from 'react-i18next'
import { view } from 'react-easy-state'
import { useNavigate } from 'react-router-dom'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { SubmitHandler, useForm } from 'react-hook-form'
import { Text, Stack } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

// validate
import newNotifyStore from '../../core/stores/Viriyah/newNotifyStore'
import userStore from '../../core/stores/Viriyah/userStore'
import FormItem from '../../components/generics/FormItem'
import ButtonChakra from '../../components/generics/ButtonChakra'
import { LoadingSpinerDataComponent } from '../../components/generics/LoadingData'

interface ValidateClaimFormState {
  motorVehicleRegistration: string
  insuredName: string
  nameTitle: string
  firstName: string
  lastName: string
  mobileNumber: string
  isRedLabelCar: boolean
}

const validationSchema = (t: TFunction<'translation', undefined>) => {
  const regExpMobileNumber = /^0[0-9]{8,9}$/i

  return yup.object().shape({
    motorVehicleRegistration: yup.string().required(t('viriyah.validate-message.make-claim.motorVehicleRegistration')),
    insuredName: yup.string(),
    nameTitle: yup.string().required(t('viriyah.validate-message.make-claim.nameTitle')),
    firstName: yup.string().required(t('viriyah.validate-message.make-claim.firstName')),
    lastName: yup.string().required(t('viriyah.validate-message.make-claim.lastName')),
    mobileNumber: yup.string().matches(regExpMobileNumber, t('viriyah.validate-message.login-form.mobileNumber')),
    isRedLabelCar: yup.boolean()
  })
}

const sleep = async (ms: number | undefined) => await new Promise(resolve => setTimeout(resolve, ms))

export default view(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [firstTimeUse, setFirstTimeUse] = useState(false)
  const [LoadingStatus, setLoadingStatus] = useState(true)

  const {
    register,
    handleSubmit,
    watch,
    getValues,
    formState: { errors, isDirty, isValid },
    reset
  } = useForm<ValidateClaimFormState>({
    defaultValues: {
      motorVehicleRegistration: '',
      insuredName: '',
      nameTitle: '',
      firstName: '',
      lastName: '',
      mobileNumber: '',
      isRedLabelCar: true
    },
    resolver: yupResolver(validationSchema(t)),
    mode: 'onChange'
  })

  const polIdMap = polId => {
    const entirePolId = polId.split('-')
    for (let i = 0; i < entirePolId.length; i++) {
      if (entirePolId[i].search('/') !== -1) {
        if (entirePolId[i + 1]) {
          return [entirePolId[i], entirePolId[i + 1]].join('-')
        }
        return entirePolId[i]
      }
    }
  }

  useEffect(() => {
    const getPolicyFromLineId = async () => {
      try {
        // const url =
        //   'https://viriyah-dev-bizlink.convolab.ai/site/biz_link/user-information-validate?lineLiffAppId=1657020200-BJp5epnV&pol_id=12122-65108/กธ/V00428'
        const url = window.location.href
        console.log('url: ', url)
        const urlParams = new URLSearchParams(url)
        const polIdSelected = urlParams.get('pol_id')

        if (!polIdSelected || firstTimeUse) {
          return ''
        }

        console.log('getPolicyFromLineId', userStore.userId)
        if (userStore.userId === '') {
          await sleep(3100)
        }

        const pathName = 'getPolicyFromLineId'
        const payload = {
          // userId: 'Ud0b40d2aca6d0cf6e877b840b09796f2',
          userId: userStore.userId,
          pol_id: polIdSelected
        }

        window.bizlink
          .trigger('POST', {
            payload,
            pathName
          })
          .then((response: any) => {
            console.log('getPolicyFromLineId response : ', response)
            if (!response.error) {
              console.log('getPolicyFromLineId success!!!')
              const {
                policy,
                cust_first_name: custFirstName,
                cust_last_name: custLastName,
                cust_province: custProvince
              } = response
              const custTitle = Object.hasOwn(response, 'cust_title') ? response.cust_title : ''

              for (let i = 0; i < policy.length; i++) {
                if (policy[i].pol_id === polIdSelected) {
                  const plateNumber = policy[i].plate_number || policy[i].pol_voluntary_plateno
                  const notifyPreName = custTitle === '' || custTitle === undefined ? 'คุณ' : custTitle
                  const notifyFName = custFirstName
                  const notifyLName = custLastName
                  const notifyPhone = '-'
                  const insureCarLicenseProvince = custProvince
                  const polId = policy[i].pol_id ? policy[i].pol_id : ''
                  const vmiPolicyNumber = policy[i].pol_name === 'ประกันภาคบังคับ (พ.ร.บ.)' ? '' : polIdMap(polId)
                  const cmiPolicyNumber = policy[i].pol_name === 'ประกันภาคบังคับ (พ.ร.บ.)' ? polIdMap(polId) : ''
                  const lineReferenceId = userStore.userId ?? ''
                  const polStartDate = policy[i].pol_start_date
                  const polEndDate = policy[i].pol_end_date

                  newNotifyStore.setUserInformation(
                    'LOA',
                    notifyPreName,
                    notifyFName,
                    notifyLName,
                    notifyPhone,
                    insureCarLicenseProvince,
                    vmiPolicyNumber,
                    cmiPolicyNumber,
                    lineReferenceId,
                    polStartDate,
                    polEndDate
                  )

                  reset({
                    motorVehicleRegistration: plateNumber,
                    insuredName: `${custTitle}${custFirstName} ${custLastName}`,
                    nameTitle: '',
                    firstName: '',
                    lastName: '',
                    isRedLabelCar:
                      plateNumber !== 'ป้ายแดง' &&
                      plateNumber !== '--' &&
                      plateNumber !== 'ปด' &&
                      plateNumber !== null &&
                      plateNumber !== ''
                  })
                  setLoadingStatus(false)
                }
              }
            } else {
              console.log('myPolicy not success!!!')
              setLoadingStatus(false)
            }
          })
          .catch(err => {
            console.log('error', pathName, 'with', err.message)
            setLoadingStatus(false)
          })
      } catch (e) {
        console.log('ERROR : ', e)
        setLoadingStatus(false)
      }
    }

    if (!firstTimeUse) {
      void getPolicyFromLineId()
      setFirstTimeUse(true)
    }
  }, [])

  const checkFormInput = (): boolean => {
    const { motorVehicleRegistration, nameTitle, firstName, lastName, mobileNumber } = watch()
    if (
      motorVehicleRegistration !== '' &&
      nameTitle !== '' &&
      firstName !== '' &&
      lastName !== '' &&
      mobileNumber !== ''
    ) {
      return false
    } else {
      return true
    }
  }

  const onSubmit: SubmitHandler<ValidateClaimFormState> = () => {
    const { motorVehicleRegistration, nameTitle, firstName, lastName, mobileNumber } = watch()
    const driverPreName = nameTitle
    const driverFName = firstName
    const driverLName = lastName
    const driverPhone = mobileNumber
    const insureCarLicense = motorVehicleRegistration

    newNotifyStore.setNewUserInformation(driverPreName, driverFName, driverLName, driverPhone, insureCarLicense)
    navigate('/make-claim-information', { replace: true })
  }

  return (
    <>
      {LoadingStatus ? (
        <LoadingSpinerDataComponent />
      ) : (
        <section id="user-information-validate-form-page" className="pt-17">
          <div className="container">
            <Text fontSize="24px" fontWeight="bold" className="title-screen">
              {t('viriyah.make-claim-page.validate.title')}
            </Text>
            <Text fontSize="16px" color="#757575">
              {t('viriyah.make-claim-page.title-alert-off')}
            </Text>

            <form id="user-information-validate-form" className="form-group" onSubmit={handleSubmit(onSubmit)}>
              {/* ทะเบียนรถ */}
              <FormItem
                mt="5%"
                mb="5%"
                label={t('viriyah.make-claim-page.validate.label-motor-vehicle-registration')}
                select="input"
                register={register}
                id="motorVehicleRegistration"
                isDisabled={getValues('isRedLabelCar')}
                placeholder={t('viriyah.make-claim-page.validate.input-placeholder-motor-vehicle-registration')}
                isError={errors.motorVehicleRegistration?.message}
                isRequired={true}
              />

              <FormItem
                mb="5%"
                label={t('viriyah.make-claim-page.validate.label-insured-name')}
                select="input"
                register={register}
                id="insuredName"
                isDisabled={true}
              />

              {/* ชื่อผู้ขับขี่ */}
              <FormItem
                mb="2%"
                label={t('viriyah.make-claim-page.validate.label-driver-name')}
                select="input"
                placeholder={t('viriyah.make-claim-page.validate.input-placeholder-name-title')}
                register={register}
                id="nameTitle"
                isError={errors.nameTitle?.message}
                isRequired={true}
              />
              <Stack spacing={5} direction="row" mb="5%">
                <FormItem
                  select="input"
                  placeholder={t('viriyah.make-claim-page.validate.input-placeholder-first-name')}
                  register={register}
                  id="firstName"
                  isError={errors.firstName?.message}
                />
                <FormItem
                  select="input"
                  placeholder={t('viriyah.make-claim-page.validate.input-placeholder-last-name')}
                  register={register}
                  id="lastName"
                  isError={errors.lastName?.message}
                />
              </Stack>

              {/* เบอร์ติดต่อ */}
              <FormItem
                mb="7%"
                label={t('viriyah.make-claim-page.validate.label-mobileNumber')}
                select="phone"
                placeholder={t('viriyah.make-claim-page.validate.input-placeholder-mobileNumber')}
                register={register}
                id="mobileNumber"
                isError={errors.mobileNumber?.message}
                isRequired={true}
              />
            </form>
          </div>
          <div className="bottom-section">
            <ButtonChakra
              customBgColor="#0033A2"
              textColor="white"
              type="submit"
              isDisable={!isDirty || !isValid}
              form="user-information-validate-form"
            >
              {t('viriyah.make-claim-page.button-submit')}
            </ButtonChakra>
          </div>
        </section>
      )}
    </>
  )
})
